// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var icon = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.primaryRed),
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(9999)),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.rem(2.25)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.rem(2.25)),
      BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.rem(0.375)),
      BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.rem(0.375)),
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.white),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.alignItems("center")
    ]);

var Styles = {
  icon: icon
};

var make = React.memo(function (props) {
      return JsxRuntime.jsx("div", {
                  children: props.children,
                  className: icon
                });
    });

export {
  Styles ,
  make ,
}
/* icon Not a pure module */
